import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { CarouselItemProps } from '../../interfaces/components';
// import { Eclipse } from '../../Icons/Eclipse';
import { Forward } from '../../Icons/Forward';
import { Backward } from '../../Icons/Backward';
import { Eclipse } from '../../Icons/Eclipse';

const CarouselItem = ({ title, body, image, total, index, onNext, onPrev }: CarouselItemProps) => {
  return (
    <Box display="flex" flexDir="column" m="0px" p="0px">
      <Image src={image} w="100%" h={['390px', '400px', '440px', '470px']} objectFit="cover" alt="carousel" />
      <Box
        display="flex"
        flexDir="column"
        gap="5"
        justifyContent="space-between"
        p={['10px 10px', '10px 10px', '0px 20px', '10px 20px']}
      >
        <Box userSelect="none" mt={['5', '5', '10']}>
          <Text
            textAlign="center"
            fontWeight="400"
            fontFamily="SangBleuBPLight"
            fontSize={['14px', '14px', '18px', '20px', '20px']}
            lineHeight={['20px', '20px', '24px', '26px', '26px']}
          >
            {title}
          </Text>
          <Text
            textAlign="center"
            fontWeight="400"
            fontFamily="JosefinSans"
            fontSize={['12px', '12px', '12px', '14px', '14px']}
            lineHeight={['16px', '16px', '16px', '18px', '18px']}
            maxW="85%"
            mx="auto"
            mt="10"
          >
            {body}
          </Text>
        </Box>

        <Box mt="3" display="flex" justifyContent="space-between" alignItems="center" p="0px 10px" h="60px !important">
          <Backward boxSize={['40px', '50px', '50px', '60px']} cursor="pointer" onClick={onPrev} />
          <Box display="flex" gap="2">
            {Array.from(Array(total).keys()).map((number: number) => (
              <Eclipse
                key={`eclipse_${index}_${total}_${number}`}
                boxSize={[3, 3, 3, 4]}
                stroke={number + 1 === index ? '#C29F6B' : '#000'}
                fill={number + 1 === index ? '#C29F6B' : '#fff'}
                strokeWidth="1px"
                borderRadius="50%"
                cursor="pointer"
              />
            ))}
          </Box>
          <Forward boxSize={['40px', '50px', '50px', '60px']} cursor="pointer" onClick={onNext} />
        </Box>
      </Box>
    </Box>
  );
};

export default CarouselItem;
